import { Directive, HostBinding } from '@angular/core';

@Directive()
export abstract class ElementDirective {
  @HostBinding('class') protected class?: string;
}
